// extracted by mini-css-extract-plugin
export default {"stat":"stat___gGWQiAw","amount":"amount___gGWQiAw","label":"label___gGWQiAw","remove":"remove___gGWQiAw"};